/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_DocumentsInputs */

const en_document_documents = /** @type {(inputs: Document_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`documents`)
};

/**
* | output |
* | --- |
* | "documents" |
*
* @param {Document_DocumentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const document_documents = /** @type {((inputs?: Document_DocumentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_DocumentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_document_documents(inputs)
});